module.exports = __webpack_public_path__ + "img/010023.d643bca8.png";